<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
      </div>
    </div>
    <div class="pub-center">
      <el-table border scrollbar-always-on   :data="list" style="width: calc(100% - 30px);position: absolute;left: 15px;top:10px;padding-bottom: 30px"  v-loading="loading">

        <el-table-column label="角色名称"   >
          <template #default="scope">
            {{scope.row.Name || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="角色描述" >
          <template #default="scope">
            {{scope.row.des || '-'}}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {USERROLE} from "@/utils/commonSetting";
const list = ref([


])
const loading = ref(false)
onMounted(()=>{
  list.value = USERROLE

})

</script>

<style scoped lang="scss">


</style>
